import {useState} from 'react'
import {Box, Input, FormControl, Text, HStack} from '@chakra-ui/react'
import {WarningIcon} from '@chakra-ui/icons'

const CustomInput = ({
  inputTitle,
  isRequired,
  description,
  isInvalid,
  isReadOnly,
  isDisabled,
  value,
  size,
  color,
  error,
  type,
  onChange,
  id,
  inputRef,
  name,
  onBlur,
  onFocus,
  maxLength,
}) => {
  const formatPhoneNumber = input => {
    const cleaned = input?.replace(/\D/g, '')

    const match = cleaned?.match(/^(\d{0,3})(\d{0,3})(\d{0,4})$/)

    let formattedNumber = ''
    if (match) {
      formattedNumber += match[1] ? `(${match[1]}` : ''
      formattedNumber += match[1] && match[2] ? ')' : ''
      formattedNumber += match[2] ? ` ${match[2]}` : ''
      formattedNumber += match[2] && match[3] ? '-' : ''
      formattedNumber += match[3] ? match[3] : ''
    }
    return formattedNumber
  }
  //only letters and hyphens
  //adding special characters
  const formatLettersOnly = input => {
    const cleaned = input?.replace(/[^A-Za-zÀ-ÖØ-öø-ÿ\s-',.]/g, '')

    const match = cleaned?.match(/^([A-Za-zÀ-ÖØ-öø-ÿ\s-',.]*)$/)

    let formattedText = ''
    if (match) {
      formattedText = match[1] ? match[1] : ''
    }
    return formattedText
  }
  //allows for letters, numbers and "- #"
  const formatAlphanumeric = input => {
    const cleaned = input?.replace(/[^A-Za-z0-9\s-#]/g, '')

    const match = cleaned?.match(/^([A-Za-z0-9\s-#]*)$/)

    let formattedText = ''
    if (match) {
      formattedText = match[1] ? match[1] : ''
    }
    return formattedText
  }

  const formatNumbersOnly = input => {
    const cleaned = input?.replace(/[^0-9]/g, '')

    const match = cleaned?.match(/^([0-9]*)$/)

    let formattedText = ''
    if (match) {
      formattedText = match[1] ? match[1] : ''
    }
    return formattedText
  }

  //Format date input to MM/DD/YYYY
  const formatDates = input => {
    //Remove non-digit characters from the input value and extract the first 8 characters (if present)
    let formattedDate = input?.replace(/\D/g, '').substring(0, 8)
    //Replace the first 2 digits of the input value with the first 2 digits of the input value followed by a slash
    formattedDate = formattedDate.replace(/^(\d\d)(\d)/g, '$1/$2')
    //Replace the next 2 digits of the input value with the first 2 digits of the input value followed by a slash
    formattedDate = formattedDate.replace(/^(\d\d\/\d\d)(\d)/g, '$1/$2')

    return formattedDate
  }

  const renderInput = () => {
    if (type === 'phone') {
      return (
        <Input
          id={id}
          name={name}
          value={formatPhoneNumber(value)}
          onChange={onChange}
          placeholder="(123) 456-7890"
          maxLength={14}
          borderColor={'pg50'}
          borderRadius=".25rem"
          isInvalid={isInvalid}
          errorBorderColor="sr60"
          isReadOnly={isReadOnly}
          opacity="1 !important"
          size={size}
          color={isDisabled ? 'pg60' : 'black'}
          isDisabled={isDisabled}
          bg={isDisabled || isReadOnly ? 'pg20' : null}
          ref={inputRef}
          onBlur={onBlur}
          onFocus={onFocus}
        />
      )
    } else if (type === 'letters') {
      return (
        <Input
          id={id}
          name={name}
          maxLength={maxLength}
          value={formatLettersOnly(value)}
          onChange={onChange}
          borderColor={'pg50'}
          borderRadius=".25rem"
          isInvalid={isInvalid}
          errorBorderColor="sr60"
          isReadOnly={isReadOnly}
          opacity="1 !important"
          size={size}
          color={isDisabled ? 'pg60' : 'black'}
          isDisabled={isDisabled}
          bg={isDisabled || isReadOnly ? 'pg20' : null}
          ref={inputRef}
          onBlur={onBlur}
          onFocus={onFocus}
        />
      )
    } else if (type === 'alphanumeric') {
      return (
        <Input
          id={id}
          name={name}
          maxLength={maxLength}
          value={formatAlphanumeric(value)}
          onChange={onChange}
          borderColor={'pg50'}
          borderRadius=".25rem"
          isInvalid={isInvalid}
          errorBorderColor="sr60"
          isReadOnly={isReadOnly}
          opacity="1 !important"
          size={size}
          color={isDisabled ? 'pg60' : 'black'}
          isDisabled={isDisabled}
          bg={isDisabled || isReadOnly ? 'pg20' : null}
          ref={inputRef}
          onBlur={onBlur}
          onFocus={onFocus}
        />
      )
    } else if (type === 'date') {
      return (
        <Input
          id={id}
          maxLength={10}
          name={name}
          value={formatDates(value)}
          onChange={onChange}
          borderColor={'pg50'}
          borderRadius=".25rem"
          isInvalid={isInvalid}
          errorBorderColor="sr60"
          isReadOnly={isReadOnly}
          opacity="1 !important"
          size={size}
          color={isDisabled ? 'pg60' : 'black'}
          isDisabled={isDisabled}
          bg={isDisabled || isReadOnly ? 'pg20' : null}
          ref={inputRef}
          onBlur={onBlur}
          onFocus={onFocus}
        />
      )
    } else if (type === 'numbers') {
      return (
        <Input
          id={id}
          maxLength={maxLength}
          name={name}
          value={formatNumbersOnly(value)}
          onChange={onChange}
          borderColor={'pg50'}
          borderRadius=".25rem"
          isInvalid={isInvalid}
          errorBorderColor="sr60"
          isReadOnly={isReadOnly}
          opacity="1 !important"
          size={size}
          color={isDisabled ? 'pg60' : 'black'}
          isDisabled={isDisabled}
          bg={isDisabled || isReadOnly ? 'pg20' : null}
          ref={inputRef}
          onBlur={onBlur}
          onFocus={onFocus}
        />
      )
    } else {
      return (
        <Input
          id={id}
          name={name}
          value={value}
          onChange={onChange}
          borderColor={'pg50'}
          isInvalid={isInvalid}
          errorBorderColor="sr60"
          isReadOnly={isReadOnly}
          opacity="1 !important"
          borderRadius={'.25rem'}
          size={size}
          color={isDisabled ? 'pg60' : 'black'}
          isDisabled={isDisabled}
          bg={isDisabled || isReadOnly ? 'pg20' : null}
          ref={inputRef}
          onBlur={onBlur}
          onFocus={onFocus}
          maxLength={maxLength}
        />
      )
    }
  }

  return (
    <Box>
      <Box mb={2}>
        {size == 'sm' ? (
          <Text textStyle="b3">
            {inputTitle}
            {isRequired && (
              <Text as="span" color="sr60" ml={1}>
                *
              </Text>
            )}
          </Text>
        ) : (
          <Text textStyle="b2">
            {inputTitle}
            {isRequired && (
              <Text as="span" color="sr60" ml={1}>
                *
              </Text>
            )}
          </Text>
        )}
      </Box>
      {renderInput()}
      {error && (
        <Box>
          <HStack>
            <Box mt={1}>
              {' '}
              <WarningIcon color="sr60" />
            </Box>
            <Box>
              <Text textStyle="c1" mt={1.5} color="sr60">
                {error}
              </Text>
            </Box>
          </HStack>
        </Box>
      )}{' '}
      <Box>
        <Text textStyle="c1" color="pg60" m={1}>
          {description && description}
        </Text>
      </Box>
    </Box>
  )
}

export default CustomInput
